const LOCAL_SIGNED_OUT_KEY = "xuno-utilities:signed-out";
const LOCAL_SIGNED_OUT_EVENT = "xuno-utilities:local-sign-out";

// Storage can throw when blocked, treat that as not signed out so the app still renders
export const isUtilitiesSignedOut = () => {
  try {
    return typeof window !== "undefined" && window.sessionStorage.getItem(LOCAL_SIGNED_OUT_KEY) === "true";
  } catch {
    return false;
  }
};

export const signOutUtilities = () => {
  window.sessionStorage.setItem(LOCAL_SIGNED_OUT_KEY, "true");
  window.dispatchEvent(new Event(LOCAL_SIGNED_OUT_EVENT));
};

export const clearUtilitiesSignOut = () => {
  window.sessionStorage.removeItem(LOCAL_SIGNED_OUT_KEY);
};

export const LOCAL_SIGNED_OUT_EVENT_NAME = LOCAL_SIGNED_OUT_EVENT;
